module.exports = __webpack_public_path__ + "static/media/banner-it-krakow.686ead96.jpg";